import { forwardRef, Ref } from "react"

type Props = {
  onSubmit: () => void
  children: React.ReactNode
  className?: string
}

export const Form = forwardRef<HTMLFormElement, Props>(
  (props: Props, ref: Ref<HTMLFormElement>) => {
    const { className, ...rest } = props
    const classes = className || "w-full max-w-[840px]"
    return (
      <form className={classes} {...rest} noValidate ref={ref}>
        {props.children}
      </form>
    )
  }
)

Form.displayName = "Form"
